import objectFitImages from "object-fit-images";

export const LAZY_LOAD_CONFIG = {
  elements_selector: ".js-lazyload",
  callback_load: el => objectFitImages(el)
};
